import Vue from 'vue'
import axios from 'axios'

const state = {
  info: null,
  professionalRegister: null,
  trainingCenters: [],
  trainingDates: [],
  trainingInfo: null,
  isLoading: false
}
const vueObj = new Vue()

const actions = {
  GET_REGISTRATION_INFO: ({ commit }, payload) => {
    commit('SET_IS_LOADING', true)
    const url = 'professionals/register/state'
    Vue.http.get(url, { params: payload.queryData })
      .then(response => {
        return response.json()
      })
      .then(response => {
        commit('SET_IS_LOADING', false)
        if (!response.error) {
          commit('SET_INFO', response.data)
          if (response.professional_register) {
            commit('SET_PROFESSIONAL_REGISTER', response.professional_register)
          }
        }
        if (payload.handler) {
          const alertMismatchTelephone = response.error_mismatch_telephone || null
          payload.handler(alertMismatchTelephone)
        }
      })
  },
  GET_TRAINING_CENTERS: ({ commit }, payload) => {
    commit('SET_IS_LOADING', true)
    commit('SET_TRAINING_CENTERS', [])
    const url = 'professionals/register/training-centers'
    Vue.http.get(url, { params: payload.queryData })
      .then(response => {
        return response.json()
      })
      .then(response => {
        commit('SET_IS_LOADING', false)
        if (!response.error) {
          commit('SET_TRAINING_CENTERS', response.data)
        }
        if (payload.handler) {
          payload.handler()
        }
      })
  },
  GET_TRAINING_DATES: ({ commit }, payload) => {
    commit('SET_IS_LOADING', true)
    commit('SET_TRAINING_DATES', [])
    const url = 'professionals/register/training-dates'
    Vue.http.get(url, { params: payload.queryData })
      .then(response => {
        return response.json()
      })
      .then(response => {
        commit('SET_IS_LOADING', false)
        if (!response.error) {
          commit('SET_TRAINING_DATES', response.data)
        }
        if (payload.handler) {
          payload.handler()
        }
      })
  },
  GET_TRAINING_INFO: ({ commit }, payload) => {
    commit('SET_IS_LOADING', true)
    commit('SET_TRAINING_INFO', null)
    const url = 'professionals/register/training-info'
    Vue.http.get(url, { params: payload.queryData })
      .then(response => {
        return response.json()
      })
      .then(response => {
        commit('SET_IS_LOADING', false)
        if (!response.error) {
          commit('SET_TRAINING_INFO', response.data)
        }
        if (payload.handler) {
          payload.handler()
        }
      })
  },
  SAVE_REGISTRATION_INFO: ({ commit }, payload) => {
    commit('SET_IS_LOADING', true)
    const url = 'professionals/register'
    Vue.http.post(url, payload.submitData)
      .then(response => {
        return response.json()
      })
      .then(response => {
        commit('SET_IS_LOADING', false)
        if (payload.handler) {
          payload.handler(response)
        }
      }).catch(err => {
        console.log('error', err)
        vueObj.$swal({
          text: 'ผิดพลาด กรุณาติดต่อเจ้าหน้าที่ [CODE: SAVE_REGISTRATION_INFO]',
          type: 'error'
        })
      })
  },
  VERIFY_VIDEO_PASSWORD: ({ commit }, payload) => {
    commit('SET_IS_LOADING', true)
    const url = 'professionals/register/verify-video-pass'
    Vue.http.post(url, payload.submitData)
      .then(response => {
        return response.json()
      })
      .then(response => {
        commit('SET_IS_LOADING', false)
        if (payload.handler) {
          payload.handler(response)
        }
      })
  },
  CHECK_STATE_AND_VALIDATION: async ({ commit }, payload) => {
    return new Promise(async (resolve, reject) => {
      commit('SET_IS_LOADING', true)
      const url = 'professionals/register/check-state-validation'
      let { data } = await axios.post(url, {
        professional_id: payload.idProfessional
      })
      if (!data.error) {
        resolve({
          error: false,
          idCardNumber: data.id_card_number,
          tel: data.tel
        })
      } else {
        reject(data.message)
      }
      commit('SET_IS_LOADING', false)
    })
  }
}

const mutations = {
  SET_IS_LOADING: (state, status) => {
    state.isLoading = status
  },
  SET_INFO: (state, info) => {
    state.info = info
  },
  SET_PROFESSIONAL_REGISTER: (state, professionalRegister) => {
    state.professionalRegister = professionalRegister
  },
  SET_TRAINING_CENTERS: (state, trainingCenters) => {
    state.trainingCenters = trainingCenters
  },
  SET_TRAINING_DATES: (state, dates) => {
    state.trainingDates = dates
  },
  SET_TRAINING_INFO: (state, info) => {
    state.trainingInfo = info
  }
}

const getters = {
  getIsLoading: state => {
    return state.isLoading
  },
  getInfo: state => {
    return state.info
  },
  getTrainingCenters: state => {
    return state.trainingCenters
  },
  getTrainingDates: state => {
    return state.trainingDates
  },
  getTrainingInfo: state => {
    return state.trainingInfo
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/professional.register.js